import styles from './Deadlines.module.css';
import React, {useState} from 'react';
import {DeadlinesTable} from './DeadlinesTable/DeadlinesTable';
import {DeadlinesChart} from './DeadlinesChart/DeadlinesChart';
import {SurfaceBar} from '../../../components/SurfaceBar/SurfaceBar';
import Button from '../../../components/Button/Button';
import {Modal} from '../../../components/Modals/Modal';
import {BindModal} from '../../../components/Modals/BindModal/BindModal';
import useFillSelect from '../../../hooks/useFillSelect.hook';
import {getAllInstructionsUrl, getAllProfessionsUrl} from '../../../helpers/constants';

export function Deadlines () {
	const [activeTab, setActiveTab] = useState('chart');
	const [presetTableTemplateId, setPresetTableTemplateId] = useState(null);
	const [isBindModalOpen, setBindModalOpen] = useState(false);

	const handleGoToTable = (templateId) => {
		setPresetTableTemplateId(templateId);
		setActiveTab('table');
	};

	const {
		itemDict: professionDict
	} = useFillSelect({
		endpoint: getAllProfessionsUrl,
		labelField: 'title'
	});

	const {
		itemDict: instructionDict
	} = useFillSelect({
		endpoint: getAllInstructionsUrl,
		labelField: 'title'
	});

	const tabs = [
		{id: 'chart', label: 'График'},
		{id: 'table', label: 'Таблица'}
	];

	return (
		<div className={styles.siz}>
			<div className={styles.outer_table}>
				<div className={styles.tabsBlock}>
					<SurfaceBar
						actions={(
							<>
								<Button onClick={() => setBindModalOpen(true)}>
									Привязки
								</Button>
								<Modal wide isOpen={isBindModalOpen} onClose={() => setBindModalOpen(false)}>
									<BindModal
										professions={Object.values(professionDict)}
										instructions={Object.values(instructionDict)}
									/>
								</Modal>
							</>
						)}
						tabs={tabs}
						activeTab={activeTab}
						onTabChange={setActiveTab}
					/>
					<div className={styles.tabContentTight}>
						{activeTab === 'table' && (
							<DeadlinesTable presetTemplateId={presetTableTemplateId} />
						)}
						{activeTab === 'chart' && (
							<DeadlinesChart onGoToTable={handleGoToTable} />
						)}
					</div>
				</div>
			</div>
		</div>
	);
}